<page-headline
    [linkTitle]="'Leads & Partners Module'"
    [module]="'leads-partners'"
    [moduleIcon]="'fa-handshake'"
    [moduleLink]="'leads-partners'"
    [pageTitle]="'Reports'"
>
</page-headline>

<p>
    This page is a placeholder.
</p>
